import React from "react";
import * as Icons from "lucide-react";
import { Link } from "react-router-dom";
import { PageBanner } from "../components/common";
import { services } from "../mock";
import Testimonials from "../sections/Testimonials";
import ContactSection from "../sections/ContactSection";

const ServicesPage = () => {
  return (
    <main>
      <PageBanner
        title="Our Services"
        crumb="Services"
        image="https://images.unsplash.com/photo-1701850009190-2859ba2aeea6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />
      <section className="py-24 bg-white">
        <div className="max-w-[1320px] mx-auto px-5 grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {services.map((s) => {
            const Icon = Icons[s.icon] || Icons.HardHat;
            return (
              <div key={s.id} className="group bg-[#F1F3F7] rounded-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="relative overflow-hidden h-56">
                  <img src={s.img} alt={s.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <span className="absolute -bottom-6 left-6 w-14 h-14 flex items-center justify-center bg-[#CD0008] text-white rounded-md">
                    <Icon size={26} />
                  </span>
                </div>
                <div className="p-7 pt-10">
                  <h3 className="font-display font-bold text-[#0B102D] text-xl mb-3">{s.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-5">{s.desc}</p>
                  <Link to="/contact" className="inline-flex items-center gap-2 font-display font-semibold text-sm uppercase tracking-wide text-[#0B102D] hover:text-[#CD0008] transition-colors">
                    Enquire Now <Icons.ArrowRight size={16} />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <Testimonials />
      <ContactSection />
    </main>
  );
};

export default ServicesPage;
